// 時長的白話（全站一個函式；SPEC PLAY「第十二輪收尾」B12-07，補第九輪 B9-13）：
// 事件清單、攝影機 › 事件分頁、事件詳細、稽核都用這一個——不到 1 秒「不到 1 秒」、60 秒內「N 秒」、1 小時內「N 分 N 秒」、以上「N 小時 N 分」。
type T = (k: string, o?: Record<string, unknown>) => string;

export function durationText(t: T, sec: number): string {
  const s = Math.max(0, Math.round(sec));
  if (s < 1) return t('evd.dur_lt1');
  if (s < 60) return t('evd.dur_s', { s });
  if (s < 3600) return t('evd.dur_ms', { m: Math.floor(s / 60), s: s % 60 });
  return t('evd.dur_hm', { h: Math.floor(s / 3600), m: Math.floor((s % 3600) / 60) });
}

/**
 * 預估保存天數（SPEC PLAY「第十二輪收尾」B12-05）：不到 1 天寫「不到 1 天（約 20 小時）」並用警示色，不寫「0 天」；
 * 1 天以上照舊寫整數天（無條件捨去）。key：'days' →「N 天」/「不到 1 天（約 N 小時）」；'retention' →「預估可保存 N 天」/「預估可保存不到 1 天（約 N 小時）」。
 */
export function retentionText(t: T, days: number, form: 'days' | 'retention' = 'days'): { text: string; short: boolean } {
  if (days < 1) {
    const h = Math.max(1, Math.round(days * 24));
    return { text: t(form === 'days' ? 'health.days_lt1' : 'health.retention_lt1', { h }), short: true };
  }
  const count = Math.floor(days);
  return { text: t(form === 'days' ? 'health.days' : 'health.retention_days', { count }), short: false };
}
